/* 
 * Click nbfs://nbhost/SystemFileSystem/Templates/Licenses/license-default.txt to change this license
 * Click nbfs://nbhost/SystemFileSystem/Templates/Other/javascript.js to edit this template
 */
import * as SNAP_HELPER from './snap_helper.js';



export class SnapGlobeMenu {
    #options;
    #menuId;
    #snapGlobe;

    constructor(options = {}){
        this.#options = options;
        this.#menuId = options['menuId'] || 'sg-globe-menu';
        this.#snapGlobe = options['snapGlobe'];

        this.#initMenu();
    }

    reset() {
        document.getElementById(this.#menuId).querySelector('input[value="cursor"]').
                dispatchEvent(
                        new MouseEvent('click', {
                            bubbles: true,
                            cancelable: true,
                            view: window
                        }));
    }

    addMenuControl(id, control, boostrapIcon, active, title) {
        let menu = document.getElementById(this.#menuId);

        menu.insertAdjacentHTML(
                'beforeend',
                `<label class="sg-globus-menu-label btn ${active ? "btn-primary active" : "btn-secondary"}">
                <input type="radio"  name="sg-globus-menu-exclusive" value="${id}" checked>
                <span class="bi ${boostrapIcon}" title='${title}' ></span>
                 </label>`
                );

        if (control) {
            this.#snapGlobe.addExclusiveControl(id, control);
        }

        let radioButton = menu.querySelector(`input[value="${id}"]`);

        radioButton.addEventListener("click", (event) => {
            event.preventDefault();
            if (this.#snapGlobe.isInitialized) {
                let code = event.target.value;
                this.#snapGlobe.deactivateAllExclusiveControls();

                Array.prototype.forEach.call(menu.getElementsByClassName('sg-globus-menu-label'),
                        (element) => {
                    element.classList.remove('btn-primary');
                    element.classList.remove('btn-secondary');
                    if (code === $(element).find('input').val()) {
                        element.classList.add('btn-primary');
                        this.#snapGlobe.activateExclusiveControl(code);
                    } else {
                        element.classList.add('btn-secondary');
                    }
                });

            }

        });
    }

    #initMenu() {
        this.addMenuControl('cursor', null, 'bi-cursor', true);
    }
}